import type { ContextRecommendationResult } from "../contract/recommendation-context-types";
import type { RecommendationInput } from "./select-study-recommendations";
import {
	buildSession,
	prepareRecommendationSelection,
} from "./select-study-recommendations";

export const selectDurationRecommendations = (
	input: RecommendationInput,
): ContextRecommendationResult => {
	const selection = prepareRecommendationSelection(input);
	if ("status" in selection) {
		return selection;
	}
	const durations = [5, 10, 20] as const;
	const sessions = durations.map((durationMinutes, index) =>
		buildSession({
			selection,
			cell: selection.candidates[index % selection.candidates.length],
			rank: index + 1,
			durationMinutes,
		}),
	);
	return {
		status: "READY",
		examId: input.context.exam.id,
		sessions,
	};
};
